import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import SaveIcon from '@material-ui/icons/Save';
import React from 'react';
import formatNum from '../../../../utils/helpers';
import { Box } from '../../../UI';

export default function Tax({ data }) {
	const { type, stampDuty, depreciation, cit, nrcgt, vatOptions, vat, handleVat } = data;

	return (
		<ExpansionPanel style={{ background: '#eee' }}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Tax</strong>
					<Tooltip title="Tax assumptions to be inserted by the user" aria-label="info">
						<IconButton color="inherit" aria-label="menu">
							<InfoIcon style={{ fontSize: '16px' }} color="primary" />
						</IconButton>
					</Tooltip>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<Box display="flex" flexDirection="column" width="100%">
					<TableContainer>
						<Table aria-label="simple table">
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Type</strong>
									</TableCell>
									<TableCell align="right">{type}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Stamp Duty</strong>
									</TableCell>
									<TableCell align="right">£{formatNum(stampDuty)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>VAT (Y/N)</strong>
									</TableCell>
									<TableCell align="right">
										<TextField select value={vat} onChange={handleVat}>
											{vatOptions.map(option => (
												<MenuItem key={option.value} value={option.value}>
													{option.label}
												</MenuItem>
											))}
										</TextField>
										<IconButton color="inherit" aria-label="menu" disabled>
											<EditIcon style={{ fontSize: '16px' }} color="primary" />
										</IconButton>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Depreciation</strong>
									</TableCell>
									<TableCell align="right">{depreciation}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>CIT</strong>
									</TableCell>
									<TableCell align="right">{cit}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>NRCGT</strong>
									</TableCell>
									<TableCell align="right">{nrcgt}%</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					<Box display="flex" justifyContent="flex-end" mt="1rem">
						<Button variant="contained" color="primary" startIcon={<SaveIcon />}>
							Save changes
						</Button>
					</Box>
				</Box>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
